var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map(function(p){return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = function(scope, key) {
	return scope && __webpack_require__.o(scope, key);
}
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = function(versions) {
	return Object.keys(versions).reduce(function(filtered, version) {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = function(scope, key, requiredVersion, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion, eager) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = function(msg) {
	throw new Error(msg);
}
var failAsNotExist = function(scopeName, key) {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ function(msg) {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = function(fn) { return function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
}; };

var useFallback = function(scopeName, key, fallback) {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	1956: function() { return loadSingletonVersion("default", "react", false, [1,16,13,0], function() { return __webpack_require__.e(4041).then(function() { return function() { return __webpack_require__(4041); }; }); }); },
	9826: function() { return loadSingletonVersion("default", "@material-ui/core", false, [1,4,9,5], function() { return Promise.all([__webpack_require__.e(7031), __webpack_require__.e(1756), __webpack_require__.e(5312), __webpack_require__.e(1286), __webpack_require__.e(9575), __webpack_require__.e(8807), __webpack_require__.e(3791)]).then(function() { return function() { return __webpack_require__(1286); }; }); }); },
	8807: function() { return loadSingletonVersion("default", "react-dom", false, [1,16,13,0], function() { return __webpack_require__.e(3144).then(function() { return function() { return __webpack_require__(3144); }; }); }); },
	3791: function() { return loadSingletonVersion("default", "@material-ui/styles", false, [1,4,10,0], function() { return __webpack_require__.e(5414).then(function() { return function() { return __webpack_require__(5414); }; }); }); },
	7621: function() { return loadSingletonVersion("default", "@poff/utils", false, [1,1], function() { return __webpack_require__.e(3359).then(function() { return function() { return __webpack_require__(3359); }; }); }); },
	8543: function() { return loadSingletonVersion("default", "@apollo/client", false, [4,3,4,16], function() { return Promise.all([__webpack_require__.e(1955), __webpack_require__.e(7727)]).then(function() { return function() { return __webpack_require__(1955); }; }); }); },
	1349: function() { return loadSingletonVersion("default", "react-router-dom", false, [1,5,2,0], function() { return __webpack_require__.e(647).then(function() { return function() { return __webpack_require__(647); }; }); }); },
	6786: function() { return loadSingletonVersion("default", "@material-ui/lab", false, [1,4,0,0,,"alpha",56], function() { return Promise.all([__webpack_require__.e(5312), __webpack_require__.e(3737), __webpack_require__.e(8807)]).then(function() { return function() { return __webpack_require__(3840); }; }); }); },
	2755: function() { return loadSingletonVersion("default", "@hookstate/core", false, [4,3,0,13], function() { return Promise.all([__webpack_require__.e(7491), __webpack_require__.e(9575)]).then(function() { return function() { return __webpack_require__(7491); }; }); }); },
	241: function() { return loadSingletonVersion("default", "@poff/auth-cli", false, [1,1], function() { return Promise.all([__webpack_require__.e(9035), __webpack_require__.e(1349), __webpack_require__.e(322)]).then(function() { return function() { return __webpack_require__(9035); }; }); }); },
	3249: function() { return loadSingletonVersion("default", "@poff/globalState", false, [1,1], function() { return Promise.all([__webpack_require__.e(5899), __webpack_require__.e(6737)]).then(function() { return function() { return __webpack_require__(9118); }; }); }); },
	6145: function() { return loadSingletonVersion("default", "@poff/content", false, [1,1], function() { return Promise.all([__webpack_require__.e(8387), __webpack_require__.e(5025), __webpack_require__.e(6786)]).then(function() { return function() { return __webpack_require__(8387); }; }); }); },
	7869: function() { return loadSingletonVersion("default", "@poff/api", false, [1,1], function() { return Promise.all([__webpack_require__.e(2166), __webpack_require__.e(5025)]).then(function() { return function() { return __webpack_require__(2166); }; }); }); },
	4601: function() { return loadSingletonVersion("default", "@poff/theme", false, [1,1], function() { return __webpack_require__.e(1208).then(function() { return function() { return __webpack_require__(8827); }; }); }); },
	5110: function() { return loadSingletonVersion("default", "@hookstate/devtools", false, [4,3,0,1], function() { return __webpack_require__.e(54).then(function() { return function() { return __webpack_require__(54); }; }); }); },
	7727: function() { return loadSingletonVersion("default", "graphql", false, [4,15,6,1], function() { return __webpack_require__.e(7040).then(function() { return function() { return __webpack_require__(7040); }; }); }); },
	5025: function() { return loadSingletonVersion("default", "axios", false, [2,0,21,4], function() { return __webpack_require__.e(6660).then(function() { return function() { return __webpack_require__(6660); }; }); }); },
	322: function() { return loadSingletonVersion("default", "keycloak-js", false, [1,11,0,2], function() { return __webpack_require__.e(5237).then(function() { return function() { return __webpack_require__(5237); }; }); }); },
	2917: function() { return loadSingletonVersion("default", "@hookstate/persistence", false, [1,3,0,1], function() { return __webpack_require__.e(3893).then(function() { return function() { return __webpack_require__(3893); }; }); }); },
	9951: function() { return loadSingletonVersion("default", "@hookstate/core", false, [4,3,0,13], function() { return __webpack_require__.e(8541).then(function() { return function() { return __webpack_require__(8541); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"322": [
		322
	],
	"1349": [
		1349
	],
	"2495": [
		7621,
		8543
	],
	"2755": [
		2755
	],
	"3791": [
		3791
	],
	"3820": [
		241,
		3249,
		6145,
		7869
	],
	"5025": [
		5025
	],
	"5899": [
		2917,
		9951
	],
	"6786": [
		6786
	],
	"7727": [
		7727
	],
	"8566": [
		4601,
		5110
	],
	"8807": [
		8807
	],
	"9575": [
		1956
	],
	"9826": [
		9826
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}